import React from 'react';
import { translate, Interpolate } from 'react-i18next';

import WorkspaceActions from 'actions/WorkspaceActions';
import UIStatusDialog from 'components/UIStatusDialog';

class WorkspaceView extends React.Component {
  constructor(props) {
    super(props);

    this.onWorkspaceInputChange = this.onWorkspaceInputChange.bind(this);
    this.onSubmitWorkspace = this.onSubmitWorkspace.bind(this);
    this.onWorkspaceSuccess = this.onWorkspaceSuccess.bind(this);
    this.onWorkspaceError = this.onWorkspaceError.bind(this);
    this.onBackToLogin = this.onBackToLogin.bind(this);

    this.state = {
      workspaceId: '',
      isSubmitting: false,
      status: {
        message: '',
        title: '',
        status: 'hide',
      },
    };
  }

  componentDidMount() {
    WorkspaceStore.on('workspace:lookup:success', this.onWorkspaceSuccess, this);
    WorkspaceStore.on('workspace:lookup:error', this.onWorkspaceError, this);
  }

  componentWillUnmount() {
    WorkspaceStore.off('workspace:lookup:success', this.onWorkspaceSuccess, this);
    WorkspaceStore.off('workspace:lookup:error', this.onWorkspaceError, this);
  }

  onWorkspaceInputChange(e) {
    this.setState({
      workspaceId: e.target.value,
      status: { message: '', title: '', status: 'hide' },
    });
  }

  onSubmitWorkspace(e) {
    e.preventDefault();
    const { workspaceId } = this.state;

    if (!workspaceId || !workspaceId.trim()) {
      this.setState({
        status: {
          title: this.props.t('WorkspaceView.error'),
          message: this.props.t('WorkspaceView.workspace_id_required'),
          status: 'error',
        },
      });
      return;
    }

    this.setState({ isSubmitting: true });
    WorkspaceActions.lookupWorkspace(workspaceId.trim());
  }

  onWorkspaceSuccess(workspaceData) {
    const workspaceId = this.state.workspaceId.trim();
    const employeeHost = workspaceData.employee_host;
    const currentHost = window.location.host;

    // If workspace is on a different host, redirect to that host
    if (employeeHost && employeeHost !== currentHost) {
      const protocol = window.location.protocol;
      window.location.href = `${protocol}//${employeeHost}/?workspace_id=${encodeURIComponent(workspaceId)}`;
    } else {
      // Same host or no employee_host specified, navigate locally
      Utils.getBrowserHistory().push(`/?workspace_id=${encodeURIComponent(workspaceId)}`);
    }
  }

  onWorkspaceError(error) {
    let message = this.props.t('WorkspaceView.workspace_not_found');

    if (error.status === 404) {
      message = this.props.t('WorkspaceView.workspace_not_found');
    } else if (error.status >= 500) {
      message = this.props.t('WorkspaceView.server_error');
    } else {
      try {
        const errorData = JSON.parse(error.responseText);
        message = errorData.error_message || message;
      } catch (e) {
        // Use default message
      }
    }

    this.setState({
      isSubmitting: false,
      status: {
        title: this.props.t('WorkspaceView.error'),
        message,
        status: 'error',
      },
    });
  }

  onBackToLogin(e) {
    e.preventDefault();
    Utils.getBrowserHistory().push('/');
  }

  render() {
    const brand = window.EmployeeWeb.ENVConfig.brand;

    return (
      <section id="workspace">
        <div className="workspace-top">
          <img src={`/images/brands/${brand}/login-logo.png`} alt={brand} />
        </div>

        <a className="back-to-login" onClick={this.onBackToLogin}>
          <button className="back-btn">
            <img src="images/back-arrow.svg" />
          </button>
          <span>{this.props.t('WorkspaceView.back_to_login')}</span>
        </a>

        <div className="workspace-header">
          <h1>{this.props.t('WorkspaceView.title')}</h1>
          <p>{this.props.t('WorkspaceView.subtitle')}</p>
        </div>

        <form onSubmit={this.onSubmitWorkspace}>
          <div className="field">
            <label htmlFor="workspace-id">
              {this.props.t('WorkspaceView.workspace_id')}
            </label>
            <input
              name="workspace-id"
              id="workspace-id"
              type="text"
              value={this.state.workspaceId}
              onChange={this.onWorkspaceInputChange}
              disabled={this.state.isSubmitting}
              placeholder={this.props.t('WorkspaceView.workspace_id_placeholder')}
            />
          </div>
          <p className="forgot-text" title={this.props.t('WorkspaceView.forgot_text')}>
            {this.props.t('WorkspaceView.forgot_workspace_id')}
          </p>

          <UIStatusDialog status={this.state.status} />

          <button
            type="submit"
            className="btn btn-center btn-link-color-dark workspace-submit-button"
            disabled={this.state.isSubmitting}
          >
            {this.state.isSubmitting
              ? this.props.t('WorkspaceView.signing_in')
              : this.props.t('WorkspaceView.sign_in')}
          </button>

          <Interpolate
            className="support-link"
            i18nKey="WorkspaceView.support_text"
            link={<a href="https://support.makeshift.ca" target="_blank">{this.props.t('WorkspaceView.support_link')}</a>}
            />
        </form>
      </section>
    );
  }
}

export default translate()(WorkspaceView);
